module.exports = __webpack_public_path__ + "img/tb2.78c47ee4.jpg";